import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss']
})
export class MultiSelectDropdownComponent implements OnInit, OnChanges {
    @Input() list: any[];
    @Output() shareCheckedList? = new EventEmitter();
    @Output() shareIndividualCheckedList? = new EventEmitter();
    checkedList: any[];
    currentSelected: {};
    listText: string;

    constructor() {
        this.checkedList = [];
    }

    /**
     * @Description:
     */
    ngOnInit() { }

    /**
     * @Description:
     */
    proceList() {
      this.checkedList = [];
      if (this.list) {
        if (this.list.length > 0) {
            this.list.forEach((row) => {
              if (row.assign === true) {
                    const objtem = {
                        companyid: row.companyid,
                        speedcode: row.speedcode,
                        assign: true
                    };
                    this.checkedList.push(objtem);
                    this.listText = this.checkedList.map(e => e.speedcode).join(', ');
                }
            });
        }
      }
    }

    /**
     * @Description:
     * @param {Boolean} status
     * @param {String} value
     * @param {number} companyid
     */
    getSelectedValue(status: Boolean, value: String, companyid: number) {
        if (status) {
            const objtem = {
                companyid : companyid,
                speedcode: value,
                assign: status
            };
            this.checkedList.push(objtem);
            this.listText = this.checkedList.map(e => e.speedcode).join(', ');
        }else {
            const index = this.checkedList.indexOf(value);
            this.checkedList.splice(index, 1 );
            this.listText = this.checkedList.map(e => e.speedcode).join(', ');
        }

        this.currentSelected = {assign : status, name: value};
        this.shareCheckedlist();
        this.shareIndividualStatus();
    }

    /**
     * @Description:
     */
    shareCheckedlist() {
        this.shareCheckedList.emit(this.checkedList);
    }

    /**
     * @Description:
     */
    shareIndividualStatus() {
        this.shareIndividualCheckedList.emit(this.currentSelected);
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['list']) {
        this.list = changes['list'].currentValue;
        this.proceList();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/multi-select-dropdown/multi-select-dropdown.component.ts